(function () {
  'use strict';

  function getReferenceButton() {
    return (
      document.querySelector('.product-form__submit') ||
      document.querySelector('.b2b-variant-matrix__submit') ||
      document.querySelector('.product-form__buttons .button') ||
      document.querySelector('button[name="add"]')
    );
  }

  function getFbtButtons() {
    return Array.from(
      document.querySelectorAll(
        [
          '.cbb-frequently-bought-add-to-cart-button',
          '.cbb-frequently-bought-add-button',
          '[class*="frequently-bought"] button[type="submit"]',
          '[class*="frequently-bought"] .button',
          '[data-cbb-bundle-add-to-cart]',
          '[data-fbt-add-to-cart]',
        ].join(', ')
      )
    );
  }

  function copyButtonClasses(referenceButton, targetButton) {
    if (!referenceButton || !targetButton || !targetButton.classList) return;

    referenceButton.classList.forEach(function (className) {
      if (!className || className === 'product-form__submit') return;
      if (!targetButton.classList.contains(className)) {
        targetButton.classList.add(className);
      }
    });
  }

  function safeAdaptFBTButtonStyles() {
    var referenceButton = getReferenceButton();
    var fbtButtons = getFbtButtons();

    if (!referenceButton || !fbtButtons.length) return;

    fbtButtons.forEach(function (fbtButton) {
      copyButtonClasses(referenceButton, fbtButton);
    });
  }

  function lockAdaptFBTButtonStyles() {
    if (safeAdaptFBTButtonStyles.__kwSafeFBT) return;

    safeAdaptFBTButtonStyles.__kwSafeFBT = true;

    try {
      Object.defineProperty(window, 'adaptFBTButtonStyles', {
        configurable: false,
        enumerable: true,
        writable: false,
        value: safeAdaptFBTButtonStyles,
      });
    } catch (error) {
      window.adaptFBTButtonStyles = safeAdaptFBTButtonStyles;
    }
  }

  lockAdaptFBTButtonStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeAdaptFBTButtonStyles);
  } else {
    safeAdaptFBTButtonStyles();
  }
})();
